module.exports = __webpack_public_path__ + "img/guanwang_1.9da42d1a.png";